import { get } from "aws-amplify/api";

const MetricsDashboardGet = async ({ resource, resourceId }) => {
  try {
    const { body } = await get({
      apiName: "boreas",
      path: "metrics/dashboard",
      options: {
        queryParams: { resource, resourceId },
      },
    }).response;
    return body.json();
  } catch (err) {
    const errorMessage = JSON.parse(err.response.body).error;
    throw errorMessage;
  }
};

const Methods = {
  MetricsDashboardGet,
};

export default Methods;
